import * as t from 'io-ts';

export const ItineraryAdditionalInformationDynamicType = t.interface({
    wifiCharges: t.union([t.string, t.null]),
    catering: t.union([t.string, t.null]),
    baggage: t.union([t.string, t.null]),
    groundTransportation: t.union([t.string, t.null]),
    helicopterConnection: t.union([t.string, t.null]),
    meetAndGreetService: t.union([t.string, t.null]),
    additionalServices: t.union([t.string, t.null]),
});

export type ItineraryAdditionalInformation = t.TypeOf<typeof ItineraryAdditionalInformationDynamicType>;
